import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HandleError, HttpErrorHandlerService } from '../http/http-error-handler.service';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { Observable } from 'rxjs';

const HTTP_OPTIONS = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class ApiEmailService {

  private httpPrefix = 'https://';
  private webPageDomain = 'dashboard.voyjaleas.com';
  private testingEmail = 'sebasjb3@gmail.com';

  // Error handling
  private handleError: HandleError;
  cache = {};

  clientName = '';
  emailMessageToSendObj = {};
  requestedPreview = false;
  loadingPreview  = false;

  
  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandlerService) { 
    this.handleError = httpErrorHandler.createHandleError('ApiEmailService');
  }

  sendPhpEmail(NewElement: any) {
    let apiUrl  = this.httpPrefix + this.webPageDomain + '/api-dashboard/email/';
    let phpFileName = 'sendEmail.php';
    apiUrl = apiUrl + phpFileName;

    return this.http.post<any>(apiUrl, NewElement, HTTP_OPTIONS)
      .pipe(
        catchError(this.handleError('addingNewElement', NewElement))
      );
  }

  getApiAssigned(queryId){
    switch(queryId){
      case 'betaProfileCreated':
      case 'profileCreated':
      case  'betaProfileCreated':
      case  'profileCreatedInvitation':
      case  'webContactForm':
      case  'newLeadCreated':
      case  'festivalForm':
      case 'sendCotizacion':
      case 'getEmailTemplateConfig':
      case 'getEmailTemplateBody':
        return 'api-dashboard';
      case 'sendMinuta':
          return 'apiDev';
      default:
        return 'default';
    }
  }

  // POST operation with the data entered to preview the email
  getEmailPreview(templateId: string, NewElement: any) {
    this.loadingPreview = true;
    let apiUrl  = this.httpPrefix + this.webPageDomain + '/api-dashboard/email/';
    let phpFileName = 'emailPreview.php';
    NewElement['templateId'] = templateId;
    apiUrl = apiUrl + phpFileName;
    return this.http.post<any>(apiUrl, NewElement, HTTP_OPTIONS).pipe(
      map((response) => {
        if (response.success) {
          this.emailMessageToSendObj['htmlBody'] = response.htmlBody;
          this.emailMessageToSendObj['postedData'] = response.postedData;
          this.emailMessageToSendObj['templateId'] = response.postedData.templateId;
          this.emailMessageToSendObj['subject'] = response.postedData.subject;
          this.emailMessageToSendObj['emailTo'] = response.postedData.emailTo;
          this.emailMessageToSendObj['from'] = response.postedData.from;
          this.emailMessageToSendObj['fromLabel'] = response.postedData.fromLabel;

          // Access posted data and generated HTML
          const { postedData, htmlBody } = response;
          this.loadingPreview = false;
          return { postedData, htmlBody };
        } else {
          this.loadingPreview = false;
          throw new Error(response.message || 'Error generating email preview');
        }
      }),
      catchError(this.handleError('addingNewElement', NewElement))
    );
  }
  
  loadTemplateConfigObject(templateCategory){
    let apiURL  = this.httpPrefix + this.webPageDomain + '/' + this.getApiAssigned('getEmailTemplateConfig') + '/email/';
    let phpFileName = 'emailConfig.php';
    let queryParam = '?queryId=getEmailTemplateConfig';
    let queryParam1 = '&templateCategory='+templateCategory;

    apiURL = apiURL + phpFileName + queryParam;
    templateCategory?  apiURL = apiURL + queryParam1 /* + queryParam2 */ : null;
    // TEMP
    let force = true;

    // Proceed
    this.sendRequestToServer(apiURL,'getEmailTemplateConfig',force);
    return this.cache['getEmailTemplateConfig'];
  }

  sendRequestToServer(url,label,force){
    if (!this.cache[label] || force) {
      this.cache[label] = this.http.get(`${url}`).pipe(
          map(data => data),
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      );
    }
  }

  cleanCache(label){
    this.cache[label] = null;
  }

  getEmailHtmlBodyReadyToSend(){
    return this.emailMessageToSendObj;
  }

  saveEmailMessageInfo(){

  }

  setConfigValue(configField,value){
    this.emailMessageToSendObj[configField] = value;
  }

  preloadCCEmails(included){
    this.setConfigValue('incudeCc',true);
  }

  requestTemplateCategories(){
    let apiURL  = this.httpPrefix + this.webPageDomain + '/api-dashboard/email/emailConfig.php?queryId=getEmailTemplateCategories';
    this.sendRequestToServer(apiURL,'getEmailTemplateCategories',true);
    return this.cache['getEmailTemplateCategories'];
  }

  isRequestedPreview(){
    return this.requestedPreview;
  }

  isPreviewLoading(){
    return this.loadingPreview;
  }
  
  requestPreview(){
    this.requestedPreview = true;
  }

  resetShowPreviewVariable(){
    this.requestedPreview = false;
  }

  
  emailSender(queryId: string, templateId: string,emailTo: string,data: any) {
    let httpMethod =  'post';
    let apiUrl  = this.httpPrefix + this.webPageDomain + '/' + this.getApiAssigned(queryId) + '/budgets/';
    let phpFileName = 'emailSender.php';
    let queryParam = '?queryId='+queryId;
    let queryParam1 = '&templateId='+templateId;
    let queryParam2 = '&to='+emailTo;

    apiUrl = apiUrl + phpFileName + queryParam;
    templateId?  apiUrl = apiUrl + queryParam1 + queryParam2 : null;

    return this.http.post<any>(apiUrl, data, HTTP_OPTIONS)
      .pipe(
        catchError(this.handleError('addingNewElement', {}))
      );
  }

  getTestingEmail(){
    return this.testingEmail;
  }

  getTestingName(){
    return 'NOMBRE_USUARIO';
  }
}
